export default __webpack_public_path__ + "static/media/iba.11291e62.png";